import {
    CORE_GET_ALL_PD_LIST_REQUEST,
    CORE_GET_ALL_PD_LIST_SUCCESS,
    CORE_GET_ALL_PD_LIST_FAILURE,
    CORE_POST_PRINT_REQUEST,
    CORE_POST_PRINT_SUCCESS,
    CORE_POST_PRINT_FAILURE,
    CORE_GET_ALL_PD_AX_LIST_REQUEST,
    CORE_GET_ALL_PD_AX_LIST_SUCCESS,
    CORE_GET_ALL_PD_AX_LIST_FAILURE,
    REQUEST_STATE
} from '../types';

const requestState = REQUEST_STATE;

export default {
    getAllPdLists: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_PD_LIST_REQUEST:
                return state;
            case CORE_GET_ALL_PD_LIST_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case CORE_GET_ALL_PD_LIST_FAILURE:
                return [];
            default:
                return state;
        }
    },
    getAllPdAxLists: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_PD_AX_LIST_REQUEST:
                return state;
            case CORE_GET_ALL_PD_AX_LIST_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case CORE_GET_ALL_PD_AX_LIST_FAILURE:
                return [];
            default:
                return state;
        }
    },
    getPrintDetail: (state = requestState, action) => {
        switch (action.type) {
            case CORE_POST_PRINT_REQUEST:
                return state;
            case CORE_POST_PRINT_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload;
                    if (result && data) {
                        return data;
                    }
                    return [];
                } else return [];
            case CORE_POST_PRINT_FAILURE:
                return [];
            default:
                return state;
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/redux/reducers/pdList.js